module.exports = __webpack_public_path__ + "img/pamplemousse_1360.c0840e46.jpg";